module.exports = __webpack_public_path__ + "static/img/doc-kid-closeup-2.a660207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Home-pics/doc-kid-closeup-2.jpg
// module id = O/gy
// module chunks = 0